module.exports = __webpack_public_path__ + "img/webnew-salon2-content-title.0f6c47a9.png";